import { Component, OnInit, ElementRef, HostListener, ViewChild, Output, Input, EventEmitter } from '@angular/core';

@Component({
  selector: 'bz-date-filter-time',
  templateUrl: './date-filter-time.component.html',
  styleUrls: ['./date-filter-time.component.scss']
})
export class DateFilterTimeComponent implements OnInit {
  @ViewChild('dpTo') dpTo: ElementRef;
  @ViewChild('dpFrom') dpFrom: ElementRef;
  @ViewChild('dpFromInput') dpFromInput: ElementRef;
  @ViewChild('dpToInput') dpToInput: ElementRef;

  @Input() dateMin: Date = new Date();
  @Input() dateMax: Date = new Date();
  @Input() titleText: string;
  @Input() isEventChange: string;
  @Input() message: string;
  @Input() showMessage: boolean = true;
  @Input() isDisabled: boolean = false;

  timePickers: any = { dpTo: false, dpFrom: false };
  pickers: any = { dpTo: false, dpFrom: false };

  @Output() onBtnFilterClick = new EventEmitter();
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (!target.closest('.date-filter')) {
      this.pickers.dpFrom = false;
      this.pickers.dpTo = false;
      this.timePickers.dpFrom = false;
      this.timePickers.dpTo = false;
    }
  }

  constructor() { }

  ngOnInit() {
    document.addEventListener('click', this.onDocumentClick.bind(this));
    const contentElement = document.querySelector('.content');
    if (contentElement) {
      contentElement.addEventListener('click', function (e) {
        if (e.target.id === 'date-from' || e.target.id === 'date-to') {
          return;
        }

        const datePicker = document.querySelector('bs-datepicker-container');
        if (datePicker != null && this.pickers.dpFrom) {
          $('#date-from').click();
          this.pickers.dpFrom = false;
          this.timePickers.dpFrom = false;
        }
        if (datePicker != null && this.pickers.dpTo) {
          $('#date-to').click();
          this.pickers.dpTo = false;
          this.timePickers.dpTo = false;
        }

      }.bind(this));
    }
  }

  ngOnDestroy() {
    document.removeEventListener('click', this.onDocumentClick.bind(this));
  }

  setDate(date: Date, zeroHour): void {
    if (zeroHour)
      date.setHours(0, 0, 0, 0);
    else
      date.setHours(23, 59, 59, 999);
  }

  public filter() {
    const dateFilter = { start: this.dateMin, end: this.dateMax };
    this.onBtnFilterClick.emit(dateFilter);
  }

  public setDatePickerActive(picker, option) {
    this.pickers.dpFrom = false;
    this.pickers.dpTo = false;
    this.timePickers.dpFrom = false;
    this.timePickers.dpTo = false;
    if (option === 0)
      this.pickers[picker] = !this.pickers[picker];
    else
      this.timePickers[picker] = !this.timePickers[picker];
  }

  public executeFilter() {
    if (this.isValidDate(this.dateMin) && this.isValidDate(this.dateMax)) {
      this.filter();
    }
  }

  public updateDate(date, option) {
    if (option === 0)
      this.dateMin = date;
    else
      this.dateMax = date;
    this.filter();
  }

  onDateMaxChange(newDate: Date) {
    this.dateMax = this.isDate(newDate);
    const inputElement = this.dpToInput.nativeElement;
    inputElement.value = this.getFormattedDate(newDate);
    this.executeFilter();
  }

  onDateMinChange(newDate: Date) {
    this.dateMin = this.isDate(newDate);
    const inputElement = this.dpFromInput.nativeElement;
    inputElement.value = this.getFormattedDate(newDate);
    this.executeFilter();
  }

  isDate(dateInput: Date) {
    if (isNaN(dateInput.getTime())) 
      return new Date();
    else
      return dateInput;
  }

  getFormattedDate(date) {
    const year = date.getFullYear();
    const month = ("0" + (date.getMonth() + 1)).slice(-2);
    const day = ("0" + date.getDate()).slice(-2);
    const hours = ('0' + date.getHours()).slice(-2);
    const minutes = ('0' + date.getMinutes()).slice(-2);
    const formattedDate = `${day}/${month}/${year} ${hours}:${minutes}`;
    return formattedDate;
  }

  isValidDate(d) {
    return d instanceof Date && !isNaN(d.getTime());
  }
}
